/** View-layer appointment shape shared across apps: the dashboard's own
 *  `Appointment` plus optional `practiceId`/`practiceName` for a multi-practice viewer. */
export interface CalendarAppointment {
    id: string;
    patientId: string;
    patientName: string;
    profilePictureUrl: string | null;
    date: string;
    time: string | null;
    reason: string | null;
    noteId: string | null;
    hasNote: boolean;
    canceledAt: string | null;
    practiceId?: string;
    practiceName?: string;
    practiceDoctorName?: string | null;
    patientInternalStatus?: string | null;
}

export interface CalendarMonth {
    year: number;
    month: number;
}

export type AppointmentTab = 'upcoming' | 'past' | 'needsNote' | 'all';

export const APPOINTMENT_TABS: ReadonlyArray<[AppointmentTab, string]> = [
    ['upcoming', 'Upcoming'],
    ['past', 'Past'],
    ['needsNote', 'Needs chart notes'],
    ['all', 'All']
];
